import { AppLayoutHeaderWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Header/HeaderWrapper";
import { AppLayoutWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Wrapper";
import { AppLayoutHeaderDesktop } from "../../Desktop/Header/AppLayoutHeader";
import { AppLayoutInnerWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/InnerWrapper";
import { AppLayoutPageWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/PageWrapper";
import { AllRoutes } from "../../Shared/Navigation/routes/AllRoutes";
import { NavigationMenuItemsTablet } from "./NavigationMenuItems";
import { NavigationMenuItemTablet } from "@src/appV2/redesign/AppLayout/Desktop/Tablet/Navigation/MenuItem";
import { NavigationMenuSectionTitleTablet } from "@src/appV2/redesign/AppLayout/Desktop/Tablet/Navigation/MenuSectionTitle";
import { NavigationMenuItemsWrapperTablet } from "@src/appV2/redesign/AppLayout/Desktop/Tablet/Navigation/MenuItemsWrapper";
import { RecentlyViewedSectionTablet } from "./RecentlyViewedSection";
import { NavScrollPillWrapper } from "../../Desktop/Navigation/NavScrollPillWrapper";
import { useNavigationTranslationLabels } from "../../Shared/Navigation/navigationMenu/translationLabels";
import { useRef } from "react";

export interface AppLayoutTabletProps {
  admin: boolean;
  isAdmin: boolean;
  isWorker: boolean;
  isWorkplace: boolean;
  userName: string;
  userId: string;
  logoutConfirm: () => void;
  logoutFromAllDevicesConfirm: () => void;
  showLogoutFromAllDevices: boolean;
  renderStartPage: () => JSX.Element | null;
}

export function AppLayoutTablet(props: AppLayoutTabletProps) {
  const {
    admin,
    isAdmin,
    isWorker,
    isWorkplace,
    logoutConfirm,
    logoutFromAllDevicesConfirm,
    showLogoutFromAllDevices,
    renderStartPage,
  } = props;
  const translationLabels = useNavigationTranslationLabels();
  const navScrollRef = useRef<HTMLDivElement>(null);

  return (
    <AppLayoutWrapperDesktop>
      <AppLayoutHeaderWrapperDesktop>
        <AppLayoutHeaderDesktop />
      </AppLayoutHeaderWrapperDesktop>
      <AppLayoutInnerWrapperDesktop>
        <NavScrollPillWrapper scrollContainerRef={navScrollRef}>
          <NavigationMenuItemsWrapperTablet ref={navScrollRef}>
            <NavigationMenuItemsTablet
              isAdmin={isAdmin}
              isWorker={isWorker}
              isWorkplace={isWorkplace}
            />
            <RecentlyViewedSectionTablet admin={admin} />
            <NavigationMenuSectionTitleTablet>
              {translationLabels.logOut}
            </NavigationMenuSectionTitleTablet>
            <NavigationMenuItemTablet
              iconType="door-straight"
              isSelected={false}
              onClick={() => {
                logoutConfirm();
              }}
            >
              {translationLabels.logOut}
            </NavigationMenuItemTablet>
            {showLogoutFromAllDevices && (
              <NavigationMenuItemTablet
                iconType="door-straight"
                isSelected={false}
                onClick={() => {
                  logoutFromAllDevicesConfirm();
                }}
              >
                {translationLabels.logOutFromAllDevices}
              </NavigationMenuItemTablet>
            )}
          </NavigationMenuItemsWrapperTablet>
        </NavScrollPillWrapper>
        <AppLayoutPageWrapperDesktop>
          <AllRoutes
            admin={admin}
            isAdmin={isAdmin}
            isWorker={isWorker}
            isWorkplace={isWorkplace}
            renderStartPage={renderStartPage}
          />
        </AppLayoutPageWrapperDesktop>
      </AppLayoutInnerWrapperDesktop>
    </AppLayoutWrapperDesktop>
  );
}
